import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { isChurchPublicPath } from "@/lib/church-public-routes";

export function AnalyticsLoader() {
  const [consentGranted, setConsentGranted] = useState(false);
  // Na página pública de igreja o marketing do Ecclesiato não entra, nem com o
  // aceite dado antes no site: senão os membros da igreja viravam público de
  // anúncio. Se a pessoa navegar depois para o site do Ecclesiato, carrega lá.
  const { pathname } = useLocation();
  const churchPublic = isChurchPublicPath(pathname);

  useEffect(() => {
    const checkConsent = () => {
      const consent = localStorage.getItem("ecclesiato-cookie-consent");
      if (consent === "accepted") {
        setConsentGranted(true);
      }
    };

    checkConsent();

    // Escuta mudanças no consentimento (disparado pelo componente CookieConsent)
    window.addEventListener("cookie-consent-updated", checkConsent);
    return () =>
      window.removeEventListener("cookie-consent-updated", checkConsent);
  }, []);

  useEffect(() => {
    if (!consentGranted || churchPublic) return;

    const gtmId = import.meta.env.VITE_GTM_ID;
    const gaId = import.meta.env.VITE_GA_MEASUREMENT_ID;
    const gadsId = import.meta.env.VITE_GADS_ID;
    const fbPixelId = import.meta.env.VITE_FB_PIXEL_ID;

    // --- 1. Google Tag Manager ---
    if (gtmId && !document.getElementById("gtm-script")) {
      const gtmScript = document.createElement("script");
      gtmScript.id = "gtm-script";
      gtmScript.innerHTML = `
        (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
        new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
        j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
        'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
        })(window,document,'script','dataLayer','${gtmId}');
      `;
      document.head.appendChild(gtmScript);
    }

    // --- 2. Google Tag (gtag.js) para GA4 & Google Ads ---
    // A tag base agora fica no index.html por exigência de verificação do Google Ads.
    // Aqui apenas atualizamos o Consent Mode para 'granted' quando o usuário aceita os cookies.
    if (typeof window !== "undefined" && window.gtag) {
      window.gtag("consent", "update", {
        ad_storage: "granted",
        ad_user_data: "granted",
        ad_personalization: "granted",
        analytics_storage: "granted",
      });
    }

    // A injeção do GA4 (caso haja um ID específico diferente do Ads) ainda pode ser feita
    if (gaId && gaId !== gadsId && !document.getElementById("gtag-ga4-init")) {
      const gtagGa4Init = document.createElement("script");
      gtagGa4Init.id = "gtag-ga4-init";
      gtagGa4Init.innerHTML = `gtag('config', '${gaId}');`;
      document.head.appendChild(gtagGa4Init);
    }

    // --- 3. Facebook Pixel ---
    if (fbPixelId && !document.getElementById("fb-pixel-script")) {
      const fbScript = document.createElement("script");
      fbScript.id = "fb-pixel-script";
      fbScript.innerHTML = `
        !function(f,b,e,v,n,t,s)
        {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
        n.callMethod.apply(n,arguments):n.queue.push(arguments)};
        if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
        n.queue=[];t=b.createElement(e);t.async=!0;
        t.src=v;s=b.getElementsByTagName(e)[0];
        s.parentNode.insertBefore(t,s)}(window, document,'script',
        'https://connect.facebook.net/en_US/fbevents.js');
        fbq('init', '${fbPixelId}');
        fbq('track', 'PageView');
      `;
      document.head.appendChild(fbScript);
    }

    console.log("Analytics scripts loaded successfully after consent.");
  }, [consentGranted, churchPublic]);

  return null;
}
